import { Box, CardContent, Typography } from '@mui/material'

/**
 * NodeCardFace — the card of a JOB / WORKFLOW node and the lines on it (`TechnologyNode`).
 */
export const NODE_CARD_SX = {
  minWidth: '6rem',
  height: '6rem',
  // Historia 152 (S87, J8): the source-process band is positioned against the card, so the card is the
  // containing block and the band never takes part in the layout.
  position: 'relative'
}

/** The resting fill of a WORKFLOW (sub-process) node. */
export const WORKFLOW_NODE_BACKGROUND_COLOR = '#02b467ff'

export const NodeCardLines = ({ referenceName = '', nodeCode = '', nodeName = '' }) => (
  <CardContent style={{ textAlign: 'center', paddingTop: 0, paddingBottom: 0, display: 'inline' }}>
    <Typography component='div'>
      {/* Historia 152 (S15, J8): a job copied from a process (`intent: 'COPY'`) may not know its technology,
          so the technology line is not rendered while empty — an empty line kept its height and pushed code
          and name to the bottom of the card. */}
      {referenceName ? <>{referenceName}<br /></> : null}
      {/* S7 revisado (PO, 23/07/2026): the node shows only its own code+name. */}
      <Box sx={{ fontStyle: 'italic', fontSize: 12 }} display='inline' data-testid='node-code-display'>{nodeCode || ''}</Box>
      {/* S6/S8 (RN01.4/RN02.3, PO 23/07/2026): an empty name is simply not rendered, never the code instead. */}
      {nodeName
        ? (
          <>
            <br />
            <Box sx={{ fontStyle: 'italic', fontSize: 12 }} display='inline' data-testid='node-name-display'>{nodeName}</Box>
          </>
          )
        : null}
    </Typography>
  </CardContent>
)
